/*
 * "Popular upgrades" tabs: a sliding pill indicator and a short staggered card entrance when a
 * tab's carousel is shown. Loaded from sections/section-tabs.liquid for section "section_tabs_iNHzGa".
 */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const root = window.Shopify?.routes?.root || '/';

  function init() {
    document.querySelectorAll('[id$="__section_tabs_iNHzGa"]').forEach((section) => {
      const tabs = section.querySelector('section-tabs');
      if (!tabs || tabs.dataset.puReady) return;
      tabs.dataset.puReady = 'true';

      const movePill = (instant) => {
        const label = tabs.querySelector('.custom-tab:has(:checked)');
        if (!label) return;
        tabs.classList.toggle('pu-pill--instant', instant);
        tabs.style.setProperty('--pu-x', `${label.offsetLeft}px`);
        tabs.style.setProperty('--pu-w', `${label.offsetWidth}px`);
        if (instant) requestAnimationFrame(() => requestAnimationFrame(() => tabs.classList.remove('pu-pill--instant')));
      };

      tabs.classList.add('pu-pill');
      movePill(true);

      if ('ResizeObserver' in window) {
        new ResizeObserver(() => movePill(true)).observe(tabs);
      }

      tabs.addEventListener('change', (event) => {
        movePill(false);
        const index = Number(event.target.value);
        let target = section;
        for (let i = 0; i < index && target; i++) target = target.nextElementSibling;
        if (target) revealCards(target);
      });
    });
  }

  function revealCards(target) {
    if (reduceMotion.matches) return;
    const slider = target.querySelector('ul.slider');
    if (slider) slider.scrollLeft = 0;
    const items = Array.from(target.querySelectorAll('ul.slider > .grid__item')).slice(0, 6);
    items.forEach((item, i) => {
      item.animate(
        [{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'translateY(0)' }],
        { duration: 320, delay: i * 40, easing: 'cubic-bezier(0.23, 1, 0.32, 1)', fill: 'backwards' }
      );
    });
  }

  /*
   * Product cards (snippets/card-product-upgrade.liquid): one-tap add to cart for single-variant
   * products; the button morphs to "Added to cart" and the header count updates. Products with
   * options use a plain "Shop now" link. Delegated, so re-rendered cards keep working.
   */
  async function updateCartCount() {
    try {
      const cart = await (await fetch(`${root}cart.js`)).json();
      const icon = document.getElementById('cart-icon-bubble');
      if (icon) {
        let bubble = icon.querySelector('.cart-count-bubble');
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble z-1 font-bold';
          bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
          icon.appendChild(bubble);
        }
        bubble.querySelector('[aria-hidden]').textContent = cart.item_count;
        bubble.querySelector('.visually-hidden').textContent = `${cart.item_count} items in cart`;
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } catch (e) {}
  }

  document.addEventListener('click', async (event) => {
    const add = event.target.closest('.pu-card [data-pu-add]');
    if (!add) return;
    event.preventDefault();
    if (add.classList.contains('is-loading')) return;

    add.classList.add('is-loading');
    try {
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(add.dataset.puAdd), quantity: 1 }] }),
      });
      if (!res.ok) throw new Error(res.status);
      updateCartCount();
      add.classList.add('is-added');
      clearTimeout(add._puTimer);
      add._puTimer = setTimeout(() => add.classList.remove('is-added'), 2200);
    } catch (error) {
      const link = add.closest('.pu-card')?.querySelector('.pu-card__title a');
      if (link) window.location.href = link.href;
    } finally {
      add.classList.remove('is-loading');
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
